import { render, staticRenderFns } from "./NewCertification.vue?vue&type=template&id=40edce02&"
import script from "./NewCertification.vue?vue&type=script&lang=js&"
export * from "./NewCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports